/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import { code } from 'codemash';
import { Config } from 'configs';
import { apiActionChooser } from 'utils/apiActionChooser';
import { manageFunctionResponse } from 'utils/errorHandler';
import { functionRequest } from './client/requests';

export const saveRKeeperCredentials = async ({
  token,
  companyId,
  restaurantId,
  credentials,
  alertController,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: Config.DATA.FUNCTIONS.SAVE_RKEEPER_CREDENTIALS,
          data: {
            token,
            restaurantId,
            ...credentials,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'SaveIntegrationCredentials',
          data: JSON.stringify({
            restaurantId,
            ...credentials,
          }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not save integration' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying save integration', e);

    if (alertController) {
      alertController.error({ text: 'Could not save integration' });
    }
  }

  return null;
};

export const getRKeeperCredentialsSetup = async ({
  token,
  companyId,
  restaurantId,
  alertController,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: Config.DATA.FUNCTIONS.GET_RKEEPER_CREDENTIALS_SETUP,
          data: {
            token,
            restaurantId,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'GetIntegrationSetup',
          data: JSON.stringify({ restaurantId }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        //
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to get integration setup', e);
  }

  return null;
};

export const updateRestrictedResources = async ({
  token,
  updateKey,
  values,
  alertController,
  companyId,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: Config.DATA.FUNCTIONS.UPDATE_RESTRICTED_RESOURCES,
          data: {
            token,
            updateKey,
            values,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'UpdateRestrictedResources',
          data: JSON.stringify({ updateKey, values }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Failed to update' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to update', e);

    if (alertController) {
      alertController.error({ text: 'Could not update resources' });
    }
  }

  return null;
};
